import * as React from 'react';

import { theme } from 'styled';

import { IconProps } from './Icon';

export const WebsiteOutlineIcon = ({
  width = 18,
  height = 18,
  color = theme.colors.text.secondary,
}: IconProps) => (
  <svg
    fill={color}
    height={height}
    viewBox="0 0 511.73 511.73"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g data-name="Layer 2" id="Layer_2">
      <g id="globe">
        <path d="m255.87 511.73a255.85 255.85 0 0 1 -144.68-466.93 255.89 255.89 0 1 1 289.35 422.13 254.45 254.45 0 0 1 -144.67 44.8zm0-481.73a225.65 225.65 0 1 0 209.45 141.17 225 225 0 0 0 -209.45-141.17z" />
        <path d="m255.87 511.73c-34.48 0-65.82-28.25-88.26-79.53-20.72-47.35-32.12-110-32.12-176.33s11.4-129 32.12-176.33c22.44-51.29 53.78-79.54 88.26-79.54s65.81 28.25 88.25 79.54c20.72 47.34 32.12 110 32.12 176.33s-11.4 129-32.12 176.33c-22.44 51.28-53.78 79.53-88.25 79.53zm0-481.73c-21.51 0-43.66 22.44-60.78 61.56-19.09 43.64-29.6 102-29.6 164.31s10.51 120.66 29.6 164.3c17.12 39.12 39.27 61.56 60.78 61.56s43.65-22.44 60.77-61.56c19.09-43.64 29.6-102 29.6-164.3s-10.51-120.67-29.6-164.31c-17.12-39.12-39.27-61.56-60.77-61.56z" />
        <path d="m479.22 180.54h-446.71a15 15 0 1 1 0-30h446.71a15 15 0 0 1 0 30z" />
        <path d="m479.22 361.19h-446.71a15 15 0 1 1 0-30h446.71a15 15 0 0 1 0 30z" />
      </g>
    </g>
  </svg>
);
